import React, { useEffect, useState } from 'react';
import { CogIcon } from '../../assets/Icons';
import SettingsModal from '../settings-modal/SettingsModal';

const Settings = () => {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
    $('#settingsModal').modal('hide');
  };

  const openModal = () => {
    setOpen(true);
  };

  // Bootstrap needs the modal DOM element to exist before .modal('show') is
  // called. Mount SettingsModal conditionally (so we never have multiple stale
  // copies of <div id="settingsModal"> in the DOM if this <Settings /> is
  // rendered more than once on a page), then trigger Bootstrap show on the
  // *next* tick after React has appended the modal.
  useEffect(() => {
    if (!open) return;
    const id = window.requestAnimationFrame(() => {
      $('#settingsModal').modal('show');
    });
    return () => window.cancelAnimationFrame(id);
  }, [open]);

  // Sync local `open` state when the user dismisses via Bootstrap (close button,
  // backdrop click, ESC) so the modal element gets unmounted and we don't leak
  // duplicate #settingsModal nodes on subsequent opens.
  useEffect(() => {
    const handler = () => setOpen(false);
    $('#settingsModal').on('hidden.bs.modal', handler);
    return () => {
      $('#settingsModal').off('hidden.bs.modal', handler);
    };
  }, []);

  return (
    <>
      {open && <SettingsModal open={open} onClose={onClose} />}
      <div className="un-action" onClick={openModal}>
        <CogIcon />
      </div>
    </>
  );
};

export default Settings;
